import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    column: {
        width: "20%"
    }
}))